import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { checkUserPaymentStatus } from '../../lib/supabase';
import { useUserStore } from '../../lib/userStore';
import toast from 'react-hot-toast';

export function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user_id, setCurrentLeagueId } = useUserStore();
  const [verified, setVerified] = useState(false);

  const leagueId = searchParams.get('league');

  useEffect(() => {
    const verifyPayment = async () => {
      if (!leagueId || !user_id) {
        navigate('/select-league');
        return;
      }

      try {
        // Attendre un peu pour que le webhook ait le temps de traiter
        await new Promise(resolve => setTimeout(resolve, 2000));
        
        const { hasPaid } = await checkUserPaymentStatus(Number(leagueId), Number(user_id));
        
        if (hasPaid) {
          setVerified(true);
          toast.success('Paiement confirmé! Bienvenue dans la ligue!');
          
          // Mettre à jour la ligue sélectionnée et rediriger
          setCurrentLeagueId(Number(leagueId));
          
          setTimeout(() => {
            navigate('/my-office');
          }, 3000);
        } else {
          toast.error('Paiement non confirmé, veuillez patienter ou contacter le support');
          setTimeout(() => {
            navigate('/select-league');
          }, 5000);
        }
      } catch (error) {
        console.error('Erreur lors de la vérification:', error);
        toast.error('Erreur lors de la vérification du paiement');
        navigate('/select-league');
      }
    };

    verifyPayment();
  }, [leagueId, user_id, navigate, setCurrentLeagueId]);

  if (!verified) {
    return (
      <div className="card shadow-lg border-0 mx-auto" style={{ maxWidth: '500px' }}>
        <div className="card-body p-5 text-center">
          <div className="mb-4">
            <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
              <span className="visually-hidden">Chargement...</span>
            </div>
          </div>
          <h2 className="card-title mb-3">Vérification du paiement...</h2>
          <p className="text-muted">
            Merci de patienter pendant que nous confirmons votre paiement.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="card shadow-lg border-0 mx-auto" style={{ maxWidth: '500px' }}>
      <div className="card-body p-5 text-center">
        <div className="text-success mb-4" style={{ fontSize: '4rem' }}>✅</div>
        <h2 className="card-title mb-4">Paiement réussi!</h2>
        <p className="text-muted mb-4">
          Votre paiement a été confirmé. Vous êtes maintenant membre de la ligue!
        </p>
        <p className="text-muted small">
          Redirection automatique vers Mon Bureau...
        </p>
      </div>
    </div>
  );
}
